// extracted by mini-css-extract-plugin
export default {"close":"styles_close__4CsRs","singleList":"styles_singleList__5VCU+","componentWrapper":"styles_componentWrapper__toDH-","edit":"styles_edit__mBQCN","active":"styles_active__1lAzI"};